import { render, staticRenderFns } from "./question-display.vue?vue&type=template&id=fc623dd8&scoped=true&"
import script from "./question-display.vue?vue&type=script&lang=js&"
export * from "./question-display.vue?vue&type=script&lang=js&"
import style0 from "./question-display.vue?vue&type=style&index=0&id=fc623dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc623dd8",
  null
  
)

export default component.exports